import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import mahasangam_1 from "../../assets/img/events/flag-off/mahasangam_1.jpg";
import mahasangam_2 from "../../assets/img/events/flag-off/mahasangam_2.jpg";
import mahasangam_3 from "../../assets/img/events/flag-off/mahasangam_3.jpg";
import mahasangam_4 from "../../assets/img/events/flag-off/mahasangam_4.jpeg";
import mahasangam_5 from "../../assets/img/events/flag-off/mahasangam_5.jpeg";
import bhagvaPressRelease_1 from "../../assets/img/events/flag-off/bhagvaPressRelease_1.jpg";
import bhagvaPressRelease_2 from "../../assets/img/events/flag-off/bhagvaPressRelease_2.jpg";
import bhagvaPressRelease_3 from "../../assets/img/events/flag-off/bhagvaPressRelease_3.jpg";
import bhagvaImpcDignitaries_1 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_1.jpeg";
import bhagvaImpcDignitaries_2 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_2.jpeg";
import bhagvaImpcDignitaries_3 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_3.jpeg";
import bhagvaImpcDignitaries_4 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_4.jpeg";
import bhagvaImpcDignitaries_6 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_6.jpeg";
import bhagvaImpcDignitaries_7 from "../../assets/img/events/flag-off/bhagvaImpcDignitaries_7.jpeg";
import event_1 from "../../assets/img/events/flag-off/event_1.jpeg";
import event_2 from "../../assets/img/events/flag-off/event_2.jpeg";
import event_3 from "../../assets/img/events/flag-off/event_3.jpg";
import event_4 from "../../assets/img/events/flag-off/event_4.jpg";
import event_5 from "../../assets/img/events/flag-off/event_5.jpeg";
import event_6 from "../../assets/img/events/flag-off/event_6.jpg";
import bhagavatrishoolyatra_clip_1 from "../../assets/videos/press-releases/bhagvatrishoolyatra_newsclip_1.mp4";
import bhagavatrishoolyatra_clip_2 from "../../assets/videos/press-releases/bhagvatrishoolyatra_newsclip_2.mp4";
import bhagavatrishoolyatra_clip_3 from "../../assets/videos/press-releases/bhagvatrishoolyatra_newsclip_3.mp4";
import cover_clip_2 from "../../assets/videos/press-releases/cover_clip_2.png";
import cover_clip_3 from "../../assets/videos/press-releases/cover_clip_3.png";

const AllEventsGallery = () => {
  return (
    <>
      <section className="bg-light py-3">
        <div className="row pt-3">
          <h2 className="text-center fw-bold about-us-yatra-title">
            MAHASANGAM YATRA
          </h2>
        </div>
        <Carousel
          interval={null}
          slide={true}
          indicators={true}
          controls={true}
          className="shadow"
        >
          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={mahasangam_1}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={mahasangam_2}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={mahasangam_3}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={mahasangam_4}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={mahasangam_5}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>

        <div className="row pt-3">
          <h2 className="text-center fw-bold about-us-yatra-title">
            BHAGVA PRESS RELEASE
          </h2>
        </div>
        <Carousel
          interval={null}
          slide={true}
          indicators={true}
          controls={true}
          className="shadow"
        >
          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaPressRelease_1}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaPressRelease_2}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaPressRelease_3}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>

        <div className="row pt-3">
          <h2 className="text-center fw-bold about-us-yatra-title">
            BHAGVA IMPC DIGNITARIES
          </h2>
        </div>
        <Carousel
          interval={null}
          slide={true}
          indicators={true}
          controls={true}
          className="shadow"
        >
          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_1}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_2}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_3}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_4}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_6}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={bhagvaImpcDignitaries_7}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>

        <div className="row pt-3">
          <h2 className="text-center fw-bold about-us-yatra-title">
            IMPC EVENTS
          </h2>
        </div>
        <Carousel
          interval={null}
          slide={true}
          indicators={true}
          controls={true}
          className="shadow"
        >
          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_1}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_2}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_3}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_4}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ minHeight: "250px", objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_5}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
                <div className="col-md-4 px-5 my-2">
                  <img
                    style={{ objectFit: "cover" }}
                    className="d-block  rounded-3"
                    src={event_6}
                    alt="First slide"
                    height="250px"
                    width="100%"
                  />
                </div>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>

        <div className="row pt-3">
          <h2 className="text-center fw-bold about-us-yatra-title">
            BHAGVA TRISHOOL YATRA UPDATES
          </h2>
        </div>

        {/* <Carousel className="border shadow py-4">
          <Carousel.Item> */}
            <div className="container">
              <div className="row py-3 d-flex align-items-end">
                <div className="col-md-4 px-5 my-2">
                  <video
                    className="rounded-5"
                    controls
                    playsInline
                    loop
                    width='100%'
                    height='100%'
                    style={{ objectFit: "cover", minHeight: '100%', minWidth: '100%' }}
                  >
                    <source
                      type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                      src={bhagavatrishoolyatra_clip_1}
                    ></source>
                  </video>
                </div>

                <div className="col-md-4 px-5 my-2">
                  <video
                    className="rounded-5"
                    controls
                    playsInline
                    loop
                    poster={cover_clip_2}
                    width='100%'
                    height='100%'
                    style={{ objectFit: "cover", minHeight: '100%', minWidth: '100%' }}
                  >
                    <source
                      type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                      src={bhagavatrishoolyatra_clip_2}
                    ></source>
                  </video>
                </div>

                <div className="col-md-4 px-5 my-2">
                  <video
                    className="rounded-5"
                    controls
                    playsInline
                    loop
                    poster={cover_clip_3}
                    width='100%'
                    height='100%'
                    style={{ objectFit: "cover", minHeight: '100%', minWidth: '100%' }}
                  >
                    <source
                      type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                      src={bhagavatrishoolyatra_clip_3}
                    ></source>
                  </video>
                </div>
              </div>
            </div>
          {/* </Carousel.Item>
        </Carousel> */}
      </section>
    </>
  );
};

export default AllEventsGallery;
